import qs from 'qs';
import axios from 'axios';

// import serviceParams from './parameters';
import { updateUserInfo, updateUserFetching } from '../../store/actions';

export function fetchUserDetails(token, dispatch) {

    axios({
        cancelToken: token,
        cancelPreviousRequest: true,
        method: 'post',
        // url: serviceParams.apiUrl,
        data: qs.stringify({
            call: 'Auth',
            type: 'get_user_details',
            output: "json"
        })
    }).then(function(res) {
        dispatch(updateUserInfo(res.data));
        dispatch(updateUserFetching(false));
    }).catch(function(res) {
        //console.log('An error occurred');
    });

}


// WEBPACK FOOTER //
// ./src/components/services/getUserDetailsService.js